<template>
  <div class="container-fluid my-4">
    <iframe
      class="w-100 border-0"
      style="height: 1200px"
      :src="'https://app.pandadoc.com/a/#/document/v1/editor/' + budget.quote.uuid + '/content'"
    ></iframe>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('budget', {
      budget: 'single'
    })
  }
}
</script>
